import { useEffect, useState } from "react"
import { PageComponent, Text, Button } from "../../components"
import './style.css'
import { API_BASE_URL } from '../../config'
import { trackCardClick } from "../get-qr/components/link-row"

const ADMIN_TOKEN_KEY = 'qr_admin_token'
// Страница get-qr по этому ключу понимает, что на неё перешли с карты (начисляет баллы)
const FROM_CARD_KEY = 'qr_from_card'

const getCodeFromPath = (): string => {
    const segments = window.location.pathname.split('/').filter(Boolean)
    return decodeURIComponent(segments[1] ?? '')
}

const resolveLink = (link: string): string => `${window.location.origin}${link}`

interface GetCodeResponse {
    message: string;
    link: string;
}

type Status = 'loading' | 'error' | 'redirecting'

const LoadComponent = ({text}: {text: string}) => (
    <div className="cards-loader">
        <span className="loader-spinner" />
        <Text size="s" color="lightGray">{text}</Text>
    </div>
)

export const CardsPage = () => {
    const [status, setStatus] = useState<Status>('loading')

    useEffect(() => {
        let cancelled = false
        const codeId = getCodeFromPath()
        const token = localStorage.getItem(ADMIN_TOKEN_KEY)

        fetch(`${API_BASE_URL}/get-code?code_id=${encodeURIComponent(codeId)}`, {
            headers: token ? {Authorization: `Bearer ${token}`} : undefined,
        })
            .then((res) => {
                if (!res.ok) throw new Error('request failed')
                return res.json()
            })
            .then((data: GetCodeResponse) => {
                if (cancelled) return
                const targetUrl = new URL(resolveLink(data.link))
                if (/^\/cards\/[^/]+\/blog\/?$/.test(window.location.pathname) && targetUrl.pathname.startsWith('/admin/')) {
                    targetUrl.searchParams.set('blog', 'true')
                }
                const target = targetUrl.toString()
                const storeMatch = new URL(target).pathname.match(/^\/(\d+)$/)
                if (storeMatch) trackCardClick(Number(storeMatch[1]))

                setStatus('redirecting')
                try {
                    sessionStorage.setItem(FROM_CARD_KEY, new URL(target).pathname)
                } catch { /* без хранилища просто не начислим баллы */ }
                window.location.href = target
            })
            .catch(() => { if (!cancelled) setStatus('error') })

        return () => { cancelled = true }
    }, [])

    if (status === 'error') {
        return (
            <PageComponent>
                <div className="card-not-found">
                    <span className="not-found-sad-face" aria-hidden="true">:(</span>
                    <Text size="m" color="lightGray">Не удалось найти такую карту</Text>
                    <Button variant="solid" textSize="s" onClick={() => window.location.assign('/')}>Заказать</Button>
                </div>
            </PageComponent>
        )
    }

    return (
        <PageComponent>
            <LoadComponent text={status === 'redirecting' ? 'Переходим по ссылке…' : 'Загрузка…'} />
        </PageComponent>
    )
}
